import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { UnifiedBulkItem } from "@src/types/UnifiedBulkRequest";
import { useUserInfo } from "@redux/slices/userInfoSlice";

interface BulkRequestState {
  bulkItemData: UnifiedBulkItem[];
}

const initialState: BulkRequestState = {
  bulkItemData: [],
};

export const bulkRequestSlice = createSlice({
  name: "bulkRequestSlice",
  initialState,
  reducers: {
    setBulkItemResponse: (state, action: PayloadAction<UnifiedBulkItem[]>) => {
      state.bulkItemData = action.payload;
    },
  },
});

export const { setBulkItemResponse } = bulkRequestSlice.actions;

export const useBulkRequestSlice = () => {
  const userInfo = useUserInfo();
  const dispatch = useDispatch();
  const bulkItemData = useSelector(
    (state: { bulkRequestSlice: BulkRequestState }) =>
      state.bulkRequestSlice.bulkItemData
  );

  const totalProductCount = () => {
    const allowedStockTypes = userInfo?.getAllowedStockTypes();
    const bulkItemProductArray = bulkItemData.filter((_item) =>
      allowedStockTypes?.includes(_item.product_type)
    );
    return bulkItemProductArray?.length ?? 0;
  };

  return {
    bulkItemData,
    totalProductCount,
    updateBulkItemResponse: (data: UnifiedBulkItem[]) => {
      let filteredArray: UnifiedBulkItem[] = [];
      if (data && data.length) {
        filteredArray = data.sort((a, b) => a.order - b.order);
      }
      dispatch(setBulkItemResponse(filteredArray));
    },
  };
};

export default bulkRequestSlice.reducer;
